module.exports = __webpack_public_path__ + "454388f3356f0d32065c0bc19fadf409.png";